/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Already_UsedInputs */

const fr_error_email_already_used = /** @type {(inputs: Error_Email_Already_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette adresse email est déjà utilisée par un autre compte. Choisissez-en une autre.`)
};

const en_error_email_already_used = /** @type {(inputs: Error_Email_Already_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another account already uses this email address. Choose a different one.`)
};

/**
* | output |
* | --- |
* | "Another account already uses this email address. Choose a different one." |
*
* @param {Error_Email_Already_UsedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_email_already_used = /** @type {((inputs?: Error_Email_Already_UsedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Already_UsedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_email_already_used(inputs)
	return fr_error_email_already_used(inputs)
});